import { Metamodel } from 'app/model/base/model';
import { IAttribute } from 'app/model/base/annotation';

import { StoreReadSettings } from './store-read-settings';
import { HttpServerLinkedService } from 'app/model/linkedservice/http-server.linkedservice';
import { Constants } from 'app/shared/shared-constants';

@Metamodel.model({
    name: 'HttpReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(HttpServerLinkedService)
    }
})

export class HttpStoreReadSettings extends StoreReadSettings {
    public static readonly REQUEST_METHOD: IAttribute;
    public static readonly ADDITIONAL_HEADERS: IAttribute;
    public static readonly REQUEST_BODY: IAttribute;
    public static readonly REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Dataset_RequestMethod,
        association: 'REQUEST_METHOD',
        templatable: true
    })
    public requestMethod?: string = 'GET';

    @Metamodel.attribute({
        display: stringResources.Dataset_AdditionalHeaders,
        association: 'ADDITIONAL_HEADERS',
        templatable: true
    })
    public additionalHeaders?: string;

    @Metamodel.attribute({
        display: stringResources.Dataset_RequestBody,
        association: 'REQUEST_BODY',
        templatable: true
    })
    public requestBody?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Request_Timeout,
        association: 'REQUEST_TIMEOUT',
        templatable: true,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public requestTimeout?: string;

    public recoverPropFromPrevOne(prevStoreSettings: StoreReadSettings): void {
        this.updateModelValue('maxConcurrentConnections', this, prevStoreSettings);
        this.updateModelValue('requestMethod', this, prevStoreSettings);
        this.updateModelValue('additionalHeaders', this, prevStoreSettings);
        this.updateModelValue('requestBody', this, prevStoreSettings);
        this.updateModelValue('requestTimeout', this, prevStoreSettings);
    }
}
